import { render, staticRenderFns } from "./courseSku.vue?vue&type=template&id=8060f962&scoped=true&"
import script from "./courseSku.vue?vue&type=script&lang=js&"
export * from "./courseSku.vue?vue&type=script&lang=js&"
import style0 from "./courseSku.vue?vue&type=style&index=0&id=8060f962&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8060f962",
  null
  
)

export default component.exports